<template>
  <section class="row navigation navigation-small">
    <button class="btn btn-warning" @click="toggleMobileMenu">
      <template v-if="menuVisible">
        Menü verstecken <i class="fa fa-remove fa-2x"></i>
      </template>
      <template v-else>
        Menü anzeigen <i class="fa fa-bars fa-2x"></i>
      </template>
    </button>

    <div v-if="menuVisible" class="navigation-items">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      menuVisible: false,
    };
  },
  methods: {
    toggleMobileMenu() {
      this.menuVisible = !this.menuVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation-items {
  background-color: var(--background-color-base);
  border: 1px solid black;
  position: absolute;
  width: 100%;
  z-index: 10;
}
</style>
